import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dd-combo',
  templateUrl: './dd-combo.component.html',
  styleUrls: ['./dd-combo.component.css']
})
export class DdComboComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
